import { useState, useEffect } from 'react';

export const useWalletAnimation = (walletAmount: number, startAnimation: boolean) => {
  const [animatedAmount, setAnimatedAmount] = useState(walletAmount);

  useEffect(() => {
    if (startAnimation) {
      setAnimatedAmount(walletAmount);

      if (walletAmount > 0) {
        const delayTimeout = setTimeout(() => {
          const interval = setInterval(() => {
            setAnimatedAmount((prev) => {
              const next = prev - 1;
              if (next <= 0) {
                clearInterval(interval);
                return 0;
              }
              return next;
            });
          }, 60);
          return () => clearInterval(interval);
        }, 1500);

        return () => {
          clearTimeout(delayTimeout);
        };
      }
    } else {
      setAnimatedAmount(walletAmount);
    }
  }, [startAnimation, walletAmount]);

  return animatedAmount;
};
